import { ScoutHost } from "generated-graphql/graphql";

import { useScoutHostContext } from "../ScoutHostContext";

type ResponsiveSpacing = number | { xs: number; sm: number };

export type ScoutMessageSpacing = {
  /** Horizontal padding for a message row's outer margin (theme spacing units). */
  rowPaddingX: ResponsiveSpacing;
  /** Horizontal padding inside the assistant content column (theme spacing units). */
  assistantContentPaddingX: number;
  /** Max width of the assistant content column within its row. */
  assistantContentMaxWidth: string;
};

/**
 * Horizontal spacing for Scout message rows, tuned per host.
 *
 * Message rows carry a 16px side gutter (rowPaddingX) with no extra assistant
 * content indent, so the Scout star, assistant text, and user bubbles all align
 * to the same edge. The scroll surface itself spans edge-to-edge so the
 * scrollbar bleeds to the edge. Assistant content still gets a per-host max
 * width so the full-page column doesn't run edge-to-edge while the narrow
 * popover uses the full available width.
 */
export function useScoutMessageSpacing(): ScoutMessageSpacing {
  const { host } = useScoutHostContext();

  if (host === ScoutHost.Popover) {
    return {
      rowPaddingX: 2,
      assistantContentPaddingX: 0,
      assistantContentMaxWidth: "100%",
    };
  }

  return {
    rowPaddingX: 2,
    assistantContentPaddingX: 0,
    assistantContentMaxWidth: "90%",
  };
}
